<template>
  <!-- 热血盲盒管理-热血盲盒管理 -->
  <div class="battle_manage-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item style="margin-left: 20px">
          <el-switch v-model="blindBoxCombat_show" :active-value="1" :inactive-value="0" active-text="对战面向全部用户"
            inactive-text="对战面向部分用户" @change="showblindBoxCombat"></el-switch>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-switch v-model="blindBoxCombat_status" :active-value="1" :inactive-value="0" active-text="热血盲盒分级房间打开"
            inactive-text="热血盲盒分级房间关闭" @change="handleblindBoxCombatEnable">
          </el-switch>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-switch v-model="dialog_status" :active-value="1" :inactive-value="0" active-text="开启加入房间弹窗"
            inactive-text="关闭加入房间弹窗" @change="changeEvent"></el-switch>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-button type="primary" @click="openCountDownTimeDialog">添加倒计时显示时间段</el-button>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-switch v-model="create_status" :active-value="1" :inactive-value="0" active-text="创建房间开关开启"
            inactive-text="创建房间开关关闭" @change="changeCreateEvent"></el-switch>
        </el-form-item>
        <el-form-item style="margin-left: 20px" label="推送顺序:">
          <el-switch v-model="push_status" :active-value="1" :inactive-value="0" active-text="前面" inactive-text="后面"
            @change="changePushEvent"></el-switch>
        </el-form-item>

        <el-form-item style="margin-left: 20px">
          <el-switch v-model="four_room_status" :active-value="1" :inactive-value="0" active-text="四人房创建开启" inactive-text="四人房创建关闭"
            @change="changeFourRoom"></el-switch>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-divider content-position="left">创建盲盒条件</el-divider>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="盲盒最多个数:">
          <el-input v-model="formData.max_room"></el-input>
        </el-form-item>
        <el-form-item style="margin-left: 20px" label="最大金额:">
          <el-input v-model="formData.max_total_price"></el-input>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-button type="primary" @click="submitLimit">保存</el-button>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-button type="primary" @click="openLimitRoomDialog">
            创建房间限制</el-button>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-button type="primary" @click="openLimitBoxDialog">
            创建盒子限制</el-button>
        </el-form-item>
      </el-form>
      <el-divider content-position="left">解决卡顿房间</el-divider>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="房间id:">
          <el-input v-model="formData1.room_id"></el-input>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-button type="primary" @click="submit1"> 提交</el-button>
        </el-form-item>
      </el-form>
      <el-divider content-position="left">一键上架或下架盒子</el-divider>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item style="margin-left: 20px">
          <el-button type="primary" @click="openBoxDialog"> 上架或下架盒子</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 弹窗 -->
    <!-- 倒计时显示时间段 -->
    <CountDownTimeDialog v-model="dialogInfos" :visible="countDownVisible" @close="countDownVisible = false">
    </CountDownTimeDialog>

    <!-- 创建房间限制弹窗 -->
    <CreateRoomLimit v-model="dialogInfos" :visible="limitRoomVisible" @close="limitRoomVisible = false">
    </CreateRoomLimit>

    <!-- 创建盒子限制弹窗 -->
    <CreateBoxLimit v-model="dialogInfos" :visible="limitBoxVisible" @close="limitBoxVisible = false">
    </CreateBoxLimit>

    <!-- 盒子一键下架或上架 -->
    <UpOrDownBoxDialog v-model="dialogInfos" :visible="boxVisible" @close="boxVisible = false">
    </UpOrDownBoxDialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'
import CountDownTimeDialog from '@/components/battle/CountDownTimeDialog.vue'
import UpOrDownBoxDialog from '@/components/battle/UpOrDownBoxDialog.vue'
import CreateRoomLimit from '@/components/battle/CreateRoomLimit.vue'
import CreateBoxLimit from '@/components/battle/CreateBoxLimit.vue'


export default {
  components: {
    CountDownTimeDialog,
    CreateRoomLimit,
    CreateBoxLimit,
    UpOrDownBoxDialog
  },
  data() {
    return {
      lock_caton: false,//解决卡顿房间锁
      limitRoomVisible: false,//创建房间限制弹窗显示标志
      limitBoxVisible: false,//创建盒子限制弹窗显示标志
      countDownVisible: false,//倒计时显示时间段配置弹窗
      boxVisible: false,//一键上架或下架
      addVisible: false,//添加队伍弹窗显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮动画
      dataList: undefined,//数据列表
      dialogInfos: undefined,//传给弹窗的数据
      blindBoxCombat_show: 0,//对战房间面向所有用户 0是关闭，1是打开
      blindBoxCombat_status: 0,//对战房间分级显示开关,0是关闭，1是打开
      dialog_status: 0,//加入房间弹窗显示,0是关闭，1是打开
      create_status: 0,//热血盲盒创建房间开关,0是关闭，1是打开
      push_status: 0,//热血盲盒推送顺序开关,0是后面，1是前面
      four_room_status: 0,//热血盲盒四人房创建开关,0是关，1是打开
      countDownfrom: {//控制倒计时开关
        start_time: '',
        end_time: '',
        enable: 0,//推送房间倒计时,0是关闭，1是打开
      },
      formData: {//盲盒创建限制条件
        max_room: '',
        max_total_price: ''
      },
      formData1: {//盲盒创建限制条件
        room_id: ''
      },
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getShowblindBoxCombatSwitch()//获取对战是否面向所有人展示的开关状态
    this.getSwitchStatus()//获取开关状态
    this.getblindBoxCombatSwitch()//获取热血盲盒分级房间开关状态
    // this.getCountDownSwitchStatus()//获取热血盲盒推送房间倒计时状态
    this.getCreateSwitchStatus()//获取热血盲盒创建房间开关状态
    this.getPushSwitchStatus()//获取热血盲盒推送房间顺序开关状态
    this.getCreatedConfig()//获取创建盲盒需要的条件
    this.getFourRoomStatus()//获取四人房间创建开关状态
  },
  methods: {
    getCreatedConfig() {
      //获取创建盲盒需要的条件
      getApiData('battle_configs')
        .then(res => {
          if (res) {
            this.formData = res
          }
        })
    },
    submitLimit() {
      //保存创建盲盒需要的条件
      let params = this.formData
      patchApiData('battle_configs', params)
        .then(res => {
          this.$message.success("保存成功！")
        })
    },
    getShowblindBoxCombatSwitch() {
      //获取关闭/打开热血盲盒分级房间按钮状态
      getApiData('battle_enable')
        .then(res => {
          if (res) {
            res.data ? this.blindBoxCombat_show = 1 : this.blindBoxCombat_show = 0
          }
        })
    },
    showblindBoxCombat() {
      //关闭/打开热血盲盒分级房间面向所有用户还是部分用户
      let params = { "black": this.blindBoxCombat_show ? 1 : 0 }
      patchApiData('battle_enable', params)
        .then(res => {
          this.$message.success('操作成功！')
          this.getShowblindBoxCombatSwitch()//刷新
        }).catch(err => {
          //关闭/打开红包按钮失败，还原标志
          this.blindBoxCombat_show = this.blindBoxCombat_show ? 0 : 1
        })
    },
    getblindBoxCombatSwitch() {
      //获取关闭/打开热血盲盒分级房间按钮状态
      getApiData('battle_list_enable')
        .then(res => {
          if (res) {
            res.data ? this.blindBoxCombat_status = 1 : this.blindBoxCombat_status = 0
          }
        })
    },
    handleblindBoxCombatEnable() {
      //关闭/打开热血盲盒分级房间关闭按钮
      let params = { "black": this.blindBoxCombat_status ? 1 : 0 }
      patchApiData('battle_list_enable', params)
        .then(res => {
          this.$message.success('操作成功！')
          this.getblindBoxCombatSwitch()//刷新
        }).catch(err => {
          //关闭/打开红包按钮失败，还原标志
          this.blindBoxCombat_status = !this.blindBoxCombat_status
        })
    },
    getSwitchStatus() {
      //获取控制加入房间弹窗显示状态按钮
      getApiData('battle_bounced')
        .then(res => {
          if (res) {
            res.data ? this.dialog_status = 1 : this.dialog_status = 0
          }
        })
    },
    changeEvent() {
      //控制加入房间弹窗显示状态按钮
      let params = { "black": this.dialog_status ? 1 : 0 }
      patchApiData('battle_bounced', params)
        .then(res => {
          this.$message.success('操作成功！')
          this.getSwitchStatus()//刷新
        }).catch(err => {
          //关闭/打开红包按钮失败，还原标志
          this.dialog_status = this.dialog_status ? 0 : 1
        })
    },
    // getCountDownSwitchStatus() {
    //   //获取控制倒计时条显示状态按钮
    //   getApiData('battle_five_push_enable')
    //     .then(res => {
    //       if (res) {
    //         this.countDownfrom = res
    //       }
    //     })
    // },
    // changeCountDownSwitchStatus() {
    //   //控制倒计时条弹窗显示状态按钮
    //   let params = this.countDownfrom
    //   if (!params.end_time) {
    //     params.end_time = ''
    //   }
    //   if (!params.start_time) {
    //     params.start_time = ''
    //   }
    //   patchApiData('battle_five_push_enable', params)
    //     .then(res => {
    //       this.$message.success('保存成功！')
    //       this.getCountDownSwitchStatus()//刷新
    //     }).catch(err => {
    //     })
    // },
    getCreateSwitchStatus() {
      //获取热血盲盒创建房间开关状态
      getApiData('battle_create_enable')
        .then(res => {
          if (res) {
            res.data ? this.create_status = 1 : this.create_status = 0
          }
        })
    },
    changeCreateEvent() {
      //修改热血盲盒创建房间开关
      let params = { "black": this.create_status ? 1 : 0 }
      patchApiData('battle_create_enable', params)
        .then(res => {
          this.$message.success('操作成功！')
          this.getCreateSwitchStatus()//刷新
        }).catch(err => {
          //关闭/打开红包按钮失败，还原标志
          this.create_status = this.create_status ? 0 : 1
        })
    },
    getPushSwitchStatus() {
      //获取热血盲盒推送房间的顺序状态
      getApiData('battle_push_seq_enable')
        .then(res => {
          if (res) {
            res.data ? this.push_status = 1 : this.push_status = 0
          }
        })
    },
    changePushEvent() {
      //修改热血盲盒推送房间的顺序开关
      let params = { "black": this.push_status ? 1 : 0 }
      patchApiData('battle_push_seq_enable', params)
        .then(res => {
          this.$message.success('操作成功！')
          this.getPushSwitchStatus()//刷新
        }).catch(err => {
          //关闭/打开红包按钮失败，还原标志
          this.push_status = this.push_status ? 0 : 1
        })
    },
    getFourRoomStatus() {
      //获取四人房间创建开关
      getApiData('mhb_four_enable')
        .then(res => {
          if (res) {
            res.data ? this.four_room_status = 1 : this.four_room_status = 0
          }
        })
    },
    changeFourRoom() {
      //修改四人房间创建开关
      let params = { "black": this.four_room_status ? 1 : 0 }
      patchApiData('mhb_four_enable', params)
        .then(res => {
          this.$message.success('操作成功！')
          this.getFourRoomStatus()//刷新
        }).catch(err => {
          //关闭/打开红包按钮失败，还原标志
          this.four_room_status = this.four_room_status ? 0 : 1
        })
    },
    openCountDownTimeDialog() {
      //打开添加免费盒子的时间段弹窗
      this.countDownVisible = true
    },
    openBoxDialog() {
      //打开一键上架或下架的东西
      this.boxVisible = true
    },
    openLimitRoomDialog() {
      //创建房间限制弹窗
      this.limitRoomVisible = true
    },
    openLimitBoxDialog() {
      //创建盒子限制弹窗
      this.limitBoxVisible = true
    },
    submit1() {
      //解决对战卡顿房间
      if (!this.formData1.room_id) {
        this.$message.warning('房间id必填！')
        return
      }
      if (this.lock_caton) {
        return
      }
      this.lock_caton = true
      let params = this.formData1
      postApiData('battle_stop_room', params)
        .then(res => {
          this.$message.success('操作成功！')
        }).catch(err => {
        }).finally(() => {
          this.lock_caton = false
        })
    }
  }
}
</script>
<style lang="less" scoped>

</style>